<template lang="pug">
	//- Слой перетаскивания файлов в чат: размывает чат и подсказывает, какие файлы можно отправить
	.ai-chat-drop-overlay
		.ai-chat-drop-overlay-content
			i.fa.fa-cloud-upload
			.ai-chat-drop-overlay-title Drop files here to send them to the AI chat
			ul.ai-chat-drop-overlay-formats
				li(v-for="group in formatGroups" :key="group.codename")
					i.fa(:class="group.icon")
					span {{group.title}}: {{group.extensions.join(', ').toUpperCase()}}
				li
					i.fa.fa-file-archive-o
					span ZIP archives (unpacked) and HTML files (base64 assets are extracted)
			.ai-chat-drop-overlay-limits Up to {{maxAttachmentFiles}} files, max {{maxAttachmentsTotalSize}} in total. The AI agent checks which files can be used as assets and imports them after your confirmation.
</template>

<script>
	import { AIAgent } 			from './../../services/AIAgent'

	export default {
		name: "AIAgentDropOverlay",
		data() {

			// Форматы файлов, которые можно использовать как ассеты, и ограничения одной отправки
			this.formatGroups = AIAgent.getAttachmentFormatGroups();
			this.maxAttachmentFiles = AIAgent.getMaxAttachmentFiles();
			this.maxAttachmentsTotalSize = AIAgent.formatAttachmentSize(AIAgent.getMaxAttachmentsTotalSize());

			return {};

		}
	}
</script>

<style lang="sass">

	.ai-chat
		// Слой перетаскивания файлов: размывает весь чат под собой
		.ai-chat-drop-overlay
			position: absolute
			top: 0
			left: 0
			right: 0
			bottom: 0
			z-index: 300
			display: flex
			align-items: center
			justify-content: center
			padding: 15px
			background-color: rgba(35,40,44,0.55)
			backdrop-filter: blur(6px)
			-webkit-backdrop-filter: blur(6px)
			border: 2px dashed #20a8d8
			overflow: hidden

			// Дочерние элементы слоя не должны вызывать dragenter / dragleave
			*
				pointer-events: none

			.ai-chat-drop-overlay-content
				display: flex
				flex-direction: column
				align-items: center
				gap: 8px
				max-width: 640px
				text-align: center
				color: #f3f4f5

				& > i.fa
					font-size: 36px
					color: #20a8d8

			.ai-chat-drop-overlay-title
				font-size: 16px
				font-weight: 600

			.ai-chat-drop-overlay-formats
				display: flex
				flex-wrap: wrap
				justify-content: center
				gap: 4px 16px
				list-style: none
				margin: 0
				padding: 0
				font-size: 12px
				color: #adb6bf

				i.fa
					margin-right: 5px
					color: #20a8d8

			.ai-chat-drop-overlay-limits
				font-size: 12px
				color: #f3f4f5

</style>
